import { useMemo } from 'react';

import { Stripe, StripeElementsOptions } from '@stripe/stripe-js';

import { useBacsPaymentFormContext } from '../context';

interface BacsPaymentFormWrapperHook {
  isLoading: boolean;
  showError: boolean;
  stripeElementsOptions?: StripeElementsOptions;
  stripePromise: PromiseLike<Stripe | null> | Stripe | null;
}

export default function useBacsPaymentFormWrapper(): BacsPaymentFormWrapperHook {
  const {
    isLoading: jobIsLoading,
    clientSecret,
    stripePromise,
    stripeAppearance,
    stripeFont,
  } = useBacsPaymentFormContext();

  const isLoading = useMemo(() => {
    if (jobIsLoading) return true;
    if (!stripeAppearance || !stripeFont || !stripePromise) return true;
    return false;
  }, [jobIsLoading, stripeAppearance, stripeFont, stripePromise]);

  const showError = useMemo(() => {
    if (isLoading) return false;
    return !clientSecret;
  }, [isLoading, clientSecret]);

  const stripeElementsOptions = useMemo(() => {
    if (isLoading) return undefined;
    return {
      clientSecret,
      appearance: stripeAppearance,
      fonts: stripeFont,
    };
  }, [isLoading, clientSecret, stripeAppearance, stripeFont]);

  return {
    isLoading,
    showError,
    stripeElementsOptions,
    stripePromise,
  };
}
